import {createReducer} from '@reduxjs/toolkit';
import {uniqBy} from 'lodash';
import {getProfile} from './actions';
import {ProfileDto} from '../../../dto/ProfileDto';

const initialState: ProfileDto[] = [];

export const profiles = createReducer(initialState, (builder) =>
    builder.addCase(getProfile.fulfilled, (state, action) => uniqBy([...state, action.payload], 'id'))
);
